// Role definitions matching backend
export const ROLES = {
  ADMIN: "admin",
  MANAGER: "manager",
  EMPLOYEE: "employee",
  CLIENT: "client",
};

// Role hierarchy (higher number = more permissions)
export const ROLE_HIERARCHY = {
  [ROLES.ADMIN]: 4,
  [ROLES.MANAGER]: 3,
  [ROLES.EMPLOYEE]: 2,
  [ROLES.CLIENT]: 1,
};

// Check if user has required role or higher
export function hasRequiredRole(userRole, requiredRole) {
  if (!userRole) return false;
  
  const userLevel = ROLE_HIERARCHY[userRole] || 0;
  const requiredLevel = ROLE_HIERARCHY[requiredRole] || 0;
  
  return userLevel >= requiredLevel;
}

// Get user role from API
export async function getUserRole(token) {
  try {
    const { API, getAuthHeaders } = await import("./constants");
    const isDevelopment = process.env.NODE_ENV === "development";
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const baseUrl = isDevelopment && isLocalhost ? "" : API.BASE_URL;
    const url = `${baseUrl}/api/admin/me/role`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        ...getAuthHeaders(token),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      // If user doesn't have admin access, default to CLIENT
      return ROLES.CLIENT;
    }

    const data = await response.json();
    return data.role || ROLES.CLIENT;
  } catch (error) {
    console.error("Error fetching user role:", error);
    return ROLES.CLIENT;
  }
}



